/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Button, Col, Modal, ModalBody, Row } from 'reactstrap';
import { DetailsModalScaffold } from '../../components/common/DetailsModalScaffold';
import { ProductTable } from '../../components/common/ProductTable';
import { Grid, Link, MenuItem, Select, Typography } from '@material-ui/core';
import { PATHS } from '../../configs/path';
import { productEditingModes } from '../../constants/productApproval';
import {
  formatUrl,
  getFormattedDate2String,
  getFormattedDateString,
  getFormattedMoneyString,
  getFormattedStatus,
  getFormattedStatusFirstCapital,
  isObjectEmptyOrNull,
  makeFirstLetterCapital,
} from '../../helpers/utils';
import { useProductTable } from '../../hooks/useProductTable';
import { BasicProductProfile } from './BasicProductProfile';
import { RentalModalContent } from './RentalDetailModal';
import { RentalReturnModal } from './RentalReturnModal';
import { RentalsTable } from './RentalsTable';
import { ReviewModal } from './ReviewModal';
import { strings } from '../../utils/strings';
import { useUserContext } from '../../context/UserContext';
import {
  MEMBER_SUBSCRIPTION_STATUS,
  NEW_ARRIVAL_URL,
} from '../../constants/appConst';
import { useLayoutContext } from '../../context/LayoutContext';
import vectorImage from '../../assets/images/Vector.png';
import { Colxx } from '../../components/common/CustomBootstrap';
import { PageTitleHeader } from '../../components/common/PageTitleHeader';
import { LinkButton } from '../../components/common/LinkButton';
import StatusPill from '../../components/common/status-pill/StatusPill';
import { Status } from '../../constants/status';
import { NotificationManager } from '../../components/common/react-notifications';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import '../../components/common/custom-card-header/customCardheader.scss';
import './rentals.scss';
import '../../assets/css/sass/views/review.scss';
import { ReviewDetailsModalScaffold } from '../../components/common/ReviewDetailsModalScaffold';
import { BackButton } from '../../components/common/BackButton';
import { ListingDetailsModalContent } from '../listing/ListingDetailsModalContent';
import { FeatureNotAvailable } from '../../components/common/feature-not-available/FeatureNotAvailable';
import { ButtonWithLoadingIcon } from '../../components/common/ButtonWithLoadingIcon';
import { RentalReturn } from './RentalReturn';
import { BecomeMemberComponent } from '../../components/common/BecomeMemberComponent';
import CloseIcon from '@material-ui/icons/Close';
import downIcon from '../../assets/images/down.svg';

export const MyRentals = () => {
  const { user, availableFreeSlot, shop } = useUserContext();

  const [rentalDetailOpen, setRentalDetailOpen] = useState(false);
  const [rentalReturnOpen, setRentalReturnOpen] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(null);

  // Routing related
  const history = useHistory();
  const match = useRouteMatch();
  const { showNavBar } = useLayoutContext();
  const [modalName, setModalName] = useState('');
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [showRentalHistory, setShowRentalHistory] = React.useState(false);
  const [product, setProduct] = React.useState(null);
  const [returnData, setRetuenData] = React.useState(null);
  const [returnStep, setReturnStep] = React.useState(1);
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  const {
    detailOpen,
    setDetailOpen,
    loadingProducts,
    products,
    setSelectedProductIndex,
    selectedProduct,
    refreshProducts,

    detailPageButtonStates,

    updateProductStatus,
    updateProductDetails,
    addProduct,

    loadingProductsHistory,
    productsHistory,
    setSelectedProductHistoryIndex,
    selectedProductHistory,
    refreshProductsHistory,
  } = useProductTable({
    status:
      selectedStatus ||
      (showRentalHistory ? 'rental_history' : 'current_rentals'),
    userID: 340,
    count: false,
  });

  const isSM = windowWidth <= 900;

  const ITEM_HEIGHT = 80;
  const ITEM_PADDING_TOP = 20;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        overflowY: 'scroll',
        width: 260,
        backgroundColor: '#fef1e7',
        borderRadius: 30,
        border: '1px solid #2E2B2B',
        boxShadow: 'none',
      },
    },
  };

  const productStatusList = showRentalHistory
    ? [
        {
          status: 'rental_history',
          status_display_user: 'View all',
        },
        {
          status: 'fit_returned_r',
          status_display_user: 'Fit returned',
        },
      ]
    : [
        {
          status: 'current_rentals',
          status_display_user: 'View all',
        },
        {
          status: 'fit_returning_r',
          status_display_user: 'Fit returning',
        },
      ];
  const rentalsColumn = [
    {
      accessor: 'last_rented_on',
      Header: 'DATE',
      cellProps: {
        style: {
          verticalAlign: 'top',
        },
      },
      Cell: (rowData) => {
        const { last_rented_on, rented_until, order_number } =
          rowData?.row?.original;
        return (
          <div className={'d-flex flex-column'}>
            <span style={{ fontSize: 14 }}>
              {last_rented_on
                ? getFormattedDate2String(last_rented_on)
                : 'null'}
            </span>
            <span
              style={{
                fontFamily: 'Brown Bold',
                fontSize: 14,
                marginVertical: 20,
              }}
            >
              Return by:{' '}
              <span>
                {rented_until ? getFormattedDate2String(rented_until) : 'null'}
              </span>
            </span>
            <span
              className='pt-2'
              style={{
                fontFamily: 'Brown',
                fontSize: 14,
                color: '#F96E4E',
              }}
            >
              Order #{order_number || '--'}
            </span>
          </div>
        );
      },
    },
    {
      accessor: 'brand',
      sortType: (rowA, rowB, id, desc) => {
        const a = rowA?.original[id]?.toLowerCase() ?? '';
        const b = rowB?.original[id]?.toLowerCase() ?? '';
        return a.localeCompare(b);
      },
      Header: 'PRODUCT DETAILS',
      Cell: (rowData) => {
        const { img_url, insurance, price, for_sale } = rowData?.row?.original;
        const { title, brand, color, size } =
          rowData?.row?.original?.data ?? {};
        return (
          <div className='d-flex'>
            <div className={'mr-2'} style={{ height: 200, width: 150 }}>
              <img
                src={img_url}
                alt={title}
                style={{ height: '100%', width: '100%' }}
                loading={'lazy'}
              />
            </div>
            <div
              className='d-flex'
              style={{ flexDirection: 'column', fontSize: 14 }}
            >
              <span style={{ fontFamily: 'Brown Bold', fontSize: 14 }}>
                {brand?.toUpperCase() || '--'}
              </span>
              <span
                className='mb-2'
                style={{ fontFamily: 'Brown', fontSize: 18 }}
              >
                {title ? makeFirstLetterCapital(title) : '--'}
              </span>
              <span style={{ color: '#F96E4E' }} className='mb-2'>
                From $0.00
                <span
                  style={{
                    textDecoration: 'line-through',
                    color: '#2E2B2B',
                    marginLeft: 15,
                  }}
                >
                  {getFormattedMoneyString(price) || '--'}
                </span>
              </span>
              <span className='mb-2'>Size: {size || '--'}</span>
              <span className='mb-2'>Color: {color || '--'}</span>
              <span className='mb-2'>
                Insurance: {insurance ? 'Yes' : 'No'}
              </span>
              <span>For sale: {for_sale ? 'Yes' : 'No'}</span>
            </div>
          </div>
        );
      },
    },
    {
      accessor: 'status',
      Header: 'STATUS',
      Cell: (rowData) => {
        const { status, status_display_user_rentals, status_color_code_user } =
          rowData?.row?.original;
        const statusData =
          status_display_user_rentals?.toLowerCase() === 'out on rent'
            ? 'rented'
            : status_display_user_rentals;
        return (
          <StatusPill
            originalStatus={status}
            status={getFormattedStatus(statusData)}
            backgroundColor={status_color_code_user || '#000000'}
          />
        );
      },
    },
    {
      accessor: 'shopify_product_url',
      Header: '',
      Cell: (rowData) => {
        const {
          shopify_product_url,
          last_rented_variant_id,
          for_sale,
          status,
        } = rowData?.row?.original;

        if (
          (status?.toLowerCase() === Status.rented ||
            status?.toLowerCase() === Status.rental_delivered_1 ||
            status?.toLowerCase() === Status.returning_r ||
            status?.toLowerCase() === Status.fit_returning_r ||
            status?.toLowerCase() === Status.returning_late_r) &&
          shopify_product_url &&
          for_sale
        ) {
          return (
            <LinkButton>
              <span
                className='a-link'
                onClick={(e) => {
                  e.preventDefault();
                  if (shopify_product_url !== null) {
                    window.open(
                      `${formatUrl(
                        shopify_product_url
                      )}?action=buy_item&variant_id=${last_rented_variant_id}`,
                      'noopener noreferrer'
                    );
                  } else {
                    NotificationManager.error({ message: 'Cannot open url' });
                  }
                }}
              >
                Buy
              </span>
            </LinkButton>
          );
        } else {
          return null;
        }
      },
    },
    {
      accessor: 'consignment_cancelled',
      Header: '',
      Cell: (rowData) => {
        const { id, status_display_user_rentals } = rowData?.row?.original;
        if (
          status_display_user_rentals?.toLowerCase() === 'ordered' ||
          status_display_user_rentals?.toLowerCase() === 'returning' ||
          status_display_user_rentals?.toLowerCase() === 'fit returning' ||
          status_display_user_rentals?.toLowerCase() === 'returning late'
        ) {
          return (
            <LinkButton
              onClick={async () => {
                setShowCancelPopup(rowData?.row?.original);
              }}
            >
              <span className={'a-link'}>Cancel</span>
            </LinkButton>
          );
        } else if (
          status_display_user_rentals?.toLowerCase() !== 'ordered' &&
          status_display_user_rentals?.toLowerCase() === 'delivered'
        ) {
          return (
            <LinkButton
              onClick={() => {
                onProductSelected(rowData.row.id, id, 'return');
              }}
            >
              <span className={'a-link'}>Return</span>
            </LinkButton>
          );
        } else {
          return null;
        }
      },
    },
    {
      accessor: 'category',

      Header: '',
      disableSortBy: true,
      Cell: (rowData) => {
        const { id, has_review, status_display_user_rentals } =
          rowData?.row?.original;
        if (status_display_user_rentals?.toLowerCase() !== 'ordered') {
          if (has_review && has_review !== '0') {
            return (
              <span style={{ fontSize: 14, opacity: '75%' }}>Reviewed</span>
            );
          } else {
            return (
              <LinkButton
                onClick={() => {
                  onProductSelected(rowData.row.id, id, 'review');
                }}
              >
                <span className={'a-link'}>Review</span>
              </LinkButton>
            );
          }
        } else {
          return null;
        }
      },
    },
  ];
  const rentalsHistoryColumn = [
    {
      accessor: 'img_url',
      Header: '',
      Cell: (rowData) => {
        const { img_url, product_title } = rowData?.row?.original;
        return (
          <div className={'mr-2'} style={{ height: 150, width: 120 }}>
            <img
              src={img_url}
              alt={product_title}
              style={{ height: '100%', width: '100%' }}
              loading={'lazy'}
            />
          </div>
        );
      },
    },
    {
      accessor: 'id',
      Header: 'ID',
      Cell: (rowData) => {
        const { id, barcode } = rowData?.row?.original;
        return (
          <span style={{ fontSize: 14 }}>
            {barcode ? barcode : id ? `#${id}` : '--'}
          </span>
        );
      },
      cellProps: {
        style: {
          width: 100,
          maxWidth: 100,
          verticalAlign: 'middle',
        },
      },
      headerProps: {
        style: {
          width: 100,
          maxWidth: 100,
        },
      },
    },
    {
      accessor: 'product_title',
      sortType: (rowA, rowB, id, desc) => {
        const a = rowA?.original[id]?.toLowerCase() ?? '';
        const b = rowB?.original[id]?.toLowerCase() ?? '';
        return a.localeCompare(b);
      },
      Header: 'TITLE',
      Cell: (rowData) => {
        const { product_title } = rowData?.row?.original;
        return <span style={{ fontSize: 14 }}>{product_title || '--'}</span>;
      },
      cellProps: {
        style: {
          width: 200,
          maxWidth: 200,
          verticalAlign: 'middle',
        },
      },
      headerProps: {
        style: {
          width: 200,
          maxWidth: 200,
        },
      },
    },
    {
      accessor: 'event_date',
      Header: 'RENTED ON',
      Cell: (rowData) => {
        const { event_date } = rowData?.row?.original;
        return (
          <span style={{ fontSize: 14 }}>
            {getFormattedDateString(event_date) || '-'}
          </span>
        );
      },
    },
    {
      accessor: 'event',
      Header: 'STATUS',
      Cell: (rowData) => {
        const { event, status_color_code_user } = rowData?.row?.original;
        const statusData = event === 'out on rent' ? 'rented' : event;
        return (
          <StatusPill
            originalStatus={event}
            status={getFormattedStatus(statusData)}
            backgroundColor={
              status_color_code_user ||
              (statusData === 'rented'
                ? '#F9D7DB'
                : statusData === 'returned_r'
                ? '#F9E4D7'
                : '#000000')
            }
          />
        );
      },
    },
    {
      accessor: 'category',
      Header: '',
      Cell: (rowData) => {
        const { id, has_review } = rowData?.row?.original;
        // if (event === 'cancelled') {
        //   return null;
        // } else {
        if (has_review && has_review !== '0') {
          return <span style={{ fontSize: 14, opacity: '75%' }}>Reviewed</span>;
        } else {
          return (
            <LinkButton
              onClick={() => {
                onProductHistorySelected(
                  rowData.row.id,
                  id,
                  'rentalHistoryReview'
                );
              }}
            >
              <span className={'a-link'}>Review</span>
            </LinkButton>
          );
        }
        // }
      },
    },
    {
      accessor: 'none',
      Header: '',
      Cell: (rowData) => {
        const { id } = rowData?.row?.original;
        return (
          <div
            style={{ cursor: 'pointer' }}
            className='glyph '
            onClick={async (e) => {
              e.preventDefault();
              history.push(`${PATHS.rentals}/${id}`); // productsRef.current[index].id);
              setSelectedProductHistoryIndex(rowData.row.id);
              setRentalDetailOpen(true);
            }}
          >
            <ArrowForwardIcon style={{ width: 34 }} />
          </div>
        );
      },
    },
  ];

  // which modal to open

  React.useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  useEffect(() => {
    // hides the product details page when back button is pressed
    if (match.params && detailOpen && match.params.id === undefined) {
      setDetailOpen(false);
    }
  }, [match.params]);

  const handleOpenAddNewModal = () => {
    setDetailOpen(true);
  };

  const getReturnStepTitle = () => {
    switch (returnStep) {
      case 1:
        return 'What would you like to return?';
      case 2:
        return 'Select a return method';
      case 3:
        return 'Schedule a pickup';
      case 4:
        return 'Review your return';
      default:
        return 'Your return has been submitted';
    }
  };

  // handles selecting and openinng product details
  const onProductSelected = useCallback((index, id, modalName = '') => {
    if (index && id) {
      history.push(`${PATHS.rentals}/${id}`); // productsRef.current[index].id);
      setSelectedProductIndex(index);
    }
    setDetailOpen(true);
    localStorage.setItem('modalOpen', JSON.stringify(true));
    setModalName(modalName);
  }, []);

  // handles selecting and openinng rentals history
  const onProductHistorySelected = useCallback((index, id, modalName = '') => {
    history.push(`${PATHS.rentals}/${id}`); // productsRef.current[index].id);
    setSelectedProductHistoryIndex(index);
    setDetailOpen(true);
    localStorage.setItem('modalOpen', JSON.stringify(true));
    setModalName(modalName);
  }, []);

  // handle close product details
  const onCloseDetailsModal = (shouldRefresh = false) => {
    if (match.params.id !== undefined) {
      history.push(PATHS.rentals);
    }
    setSelectedProductIndex(-1);
    if (shouldRefresh) {
      refreshProducts();
    }
    setDetailOpen(false);
    localStorage.setItem('modalOpen', JSON.stringify(false));
  };

  const onCloseRentalHistoryDetailsModal = (shouldRefresh = false) => {
    if (match.params.id !== undefined) {
      history.push(PATHS.rentals);
    }
    setSelectedProductIndex(-1);
    if (shouldRefresh) {
      refreshProducts();
    }
    setRentalDetailOpen(false);
    localStorage.setItem('modalOpen', JSON.stringify(false));
  };

  const onCloseHistoryDetailsModal = (shouldRefresh = false) => {
    if (match.params.id !== undefined) {
      history.push(PATHS.rentals);
    }
    setSelectedProductHistoryIndex(-1);
    if (shouldRefresh) {
      refreshProductsHistory();
    }
    setDetailOpen(false);
    localStorage.setItem('modalOpen', JSON.stringify(false));
  };

  const defaultSlots = shop?.rental_slots_default ?? 0;
  const totalSlots = availableFreeSlot ? availableFreeSlot : defaultSlots;
  const totalRentals = products?.length ?? 0;
  const availableSlots = totalSlots - totalRentals;
  const freeSlots = user?.free_slots ?? 0;

  if (loadingProducts || loadingProductsHistory) {
    return (
      <div
        className='loading-overlay'
        style={{ backgroundColor: 'transparent' }}
      >
        <div className='loading'></div>
      </div>
    );
  } else {
    return (
      <Row style={!showNavBar ? { justifyContent: 'center' } : {}}>
        {showCancelPopup ? (
          <Modal
            centered
            isOpen={showCancelPopup}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 'none',
              maxWidth: 500,
            }}
            contentClassName={'loader-modal-content'}
          >
            <div
              onClick={() => {
                if (!cancelling) {
                  setShowCancelPopup(null);
                }
              }}
              className='d-flex'
              style={{
                justifyContent: 'flex-end',
                paddingTop: 10,
                paddingRight: 10,
              }}
            >
              <CloseIcon />
            </div>
            <ModalBody
              style={{
                backgroundColor: 'transparent',
                padding: 80,
                paddingTop: 46,
              }}
            >
              <div
                style={{
                  backgroundColor: 'transparent',
                  flexDirection: 'column',
                  display: 'flex',
                }}
              >
                <span
                  style={{
                    fontSize: 22,
                    marginBottom: 16,
                    textAlign: 'center',
                  }}
                >
                  Are you sure?
                </span>
                <span
                  style={{
                    fontSize: 16,
                    marginBottom: 32,
                    textAlign: 'center',
                  }}
                >
                  {showCancelPopup?.status === Status.returning_r ||
                  showCancelPopup?.status === Status.fit_returning_r ||
                  showCancelPopup?.status === Status.returning_late_r
                    ? 'Are you sure you want to cancel this return?'
                    : 'Are you sure you want to cancel this order?'}
                </span>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <ButtonWithLoadingIcon
                    type='submit'
                    color='primary'
                    size='sm'
                    height={36}
                    style={{ width: 165, backgroundColor: 'transparent' }}
                    className={'px-5'}
                    onClick={() => setShowCancelPopup(null)}
                    disabled={cancelling}
                  >
                    NO
                  </ButtonWithLoadingIcon>
                  <ButtonWithLoadingIcon
                    disabled={cancelling}
                    type='submit'
                    loading={cancelling}
                    color='primary'
                    size='sm'
                    height={36}
                    className={'px-5'}
                    style={{ width: 165, backgroundColor: '#D2B6DF' }}
                    onClick={async () => {
                      setCancelling(true);
                      if (showCancelPopup?.id) {
                        const status = {
                          id: showCancelPopup?.id,
                          user_id: user.id,
                          status:
                            showCancelPopup?.status?.toLowerCase() ===
                              'returning_r' ||
                            showCancelPopup?.status?.toLowerCase() ===
                              'fit_returning_r' ||
                            showCancelPopup?.status?.toLowerCase() ===
                              'returning_late_r'
                              ? Status.rental_delivered_1
                              : Status.cancel_order,
                          order_id: showCancelPopup?.order_number || null,
                        };
                        await updateProductStatus(status, '', (updateRes) => {
                          if (updateRes?.success) {
                            setCancelling(false);
                            setShowCancelPopup(null);
                            NotificationManager.success({
                              message: 'Cancel successfully done',
                            });
                          } else {
                            setShowCancelPopup(null);
                            setCancelling(false);
                            NotificationManager.error({
                              message: 'Something went wrong',
                            });
                          }
                        });
                      }
                    }}
                  >
                    YES
                  </ButtonWithLoadingIcon>
                </div>
              </div>
            </ModalBody>
          </Modal>
        ) : null}
        {/* {cancelling ? (
          <Modal
            centered
            isOpen={cancelling}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 'none',
            }}
            contentClassName={'loader-modal-content'}
          >
            <ModalBody style={{ backgroundColor: 'transparent' }}>
              <div
                className='loading-overlay'
                style={{ backgroundColor: 'transparent' }}
              >
                <div className='loading'></div>
              </div>
            </ModalBody>
          </Modal>
        ) : null} */}
        {user.member_status !== MEMBER_SUBSCRIPTION_STATUS.CANCELLED ? (
          <>
            <Colxx xxs='12' className='mb-2'>
              <Row style={{ marginBottom: 25 }}>
                <PageTitleHeader
                  className={'mb-0'}
                  title={
                    rentalDetailOpen
                      ? 'Rental Details'
                      : rentalReturnOpen
                      ? getReturnStepTitle()
                      : showRentalHistory
                      ? 'Rental History'
                      : 'Rentals'
                  }
                />
                <div className='label mb-3 text-center pt-3 w-100'>
                  <span
                    className='link-text'
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      if (!rentalDetailOpen) {
                        setSelectedStatus(null);
                      }
                      rentalDetailOpen
                        ? setRentalDetailOpen(false)
                        : showRentalHistory
                        ? setShowRentalHistory(false)
                        : rentalReturnOpen
                        ? setRentalReturnOpen(false)
                        : setShowRentalHistory(true);
                    }}
                  >
                    {rentalDetailOpen
                      ? 'Back to rental history'
                      : showRentalHistory
                      ? 'Back to rentals'
                      : rentalReturnOpen
                      ? 'Back to rentals'
                      : 'View rental history'}
                  </span>
                </div>
              </Row>
            </Colxx>
            {rentalDetailOpen ? null : (
              <Colxx
                xxs='12'
                sm='12'
                md='12'
                lg='12'
                xl='10'
                className='mb-3 d-flex'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <Col
                  xs='12'
                  sm='6'
                  md='5'
                  lg='5'
                  xl='4'
                  style={{ alignItems: 'flex-end' }}
                >
                  <Select
                    value={selectedStatus || ''}
                    name='productStatus'
                    id='productStatus'
                    displayEmpty
                    disableUnderline
                    MenuProps={MenuProps}
                    IconComponent={() => {
                      return (
                        <img
                          src={downIcon}
                          style={{ height: 14, width: 14 }}
                          alt={'down'}
                        />
                      );
                    }}
                    onChange={(e) => {
                      setSelectedStatus(e.target.value);
                      // handleSubmit(e.target.value);
                    }}
                    className={
                      'd-flex align-items-center justify-content-center px-3 select-dropdown'
                    }
                    style={{ borderRadius: 30, height: 51, marginTop: 10 }}
                    inputProps={{ 'aria-label': 'Without label' }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <span>Filter by status</span>;
                      }
                      const selectedStatusData = productStatusList.find(
                        (p) => p.status === selected
                      );
                      if (
                        selectedStatusData &&
                        selectedStatusData.status_display_user
                      ) {
                        return getFormattedStatusFirstCapital(
                          selectedStatusData.status_display_user
                        );
                      } else {
                        return selected[selected];
                      }
                    }}
                  >
                    {/* <MenuItem
                      value={''}
                      disabled
                      style={{
                        paddingTop: 8,
                        paddingBottom: 8,
                        fontSize: 16,
                        fontFamily: 'Brown',
                        borderBottom: `1px solid #2E2B2B`,
                        justifyContent: 'space-between',
                        backgroundColor: 'transparent',
                      }}
                    >
                      <span style={{ fontSize: 16, fontFamily: 'Brown' }}>
                        Filter by status
                      </span>
                      <img
                        src={upIcon}
                        style={{ height: 13, width: 12 }}
                        alt={'up'}
                      />
                    </MenuItem> */}

                    {productStatusList.map((opt, index) => {
                      return (
                        <MenuItem
                          value={opt.status}
                          style={{
                            paddingTop: 10,
                            paddingBottom: 10,
                            fontSize: 16,
                            fontFamily: 'Brown',
                            backgroundColor:
                              selectedStatus === opt.status
                                ? '#F9E4D7'
                                : 'transparent',
                          }}
                          disableRipple
                          disableTouchRipple
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = '#F9E4D7')
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = 'transparent')
                          }
                        >
                          {getFormattedStatusFirstCapital(
                            opt.status_display_user
                          )}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Col>
              </Colxx>
            )}
            {rentalDetailOpen ? (
              <Col sm='12' md='12' lg='12' xl='10' className='mx-autos'>
                <ListingDetailsModalContent
                  productData={selectedProductHistory}
                  isSM={isSM}
                  onCloseModal={onCloseRentalHistoryDetailsModal}
                  isRental
                />
              </Col>
            ) : rentalReturnOpen ? (
              <Col sm='12' md='12' lg='12' xl='10' className='mx-autos'>
                <RentalReturn
                  onClose={() => setRentalReturnOpen(false)}
                  productList={products}
                  step={returnStep}
                  onNextClick={(selectedData) => {
                    setProduct(selectedData?.selectedProduct);
                    if (
                      returnStep === 2 &&
                      !selectedData?.selectedMethod?.isPickup
                    ) {
                      setReturnStep(4);
                    } else {
                      setReturnStep(returnStep + 1);
                    }
                  }}
                  onClickDone={() => {
                    setRentalReturnOpen(false);
                  }}
                  onPreviousClick={(selectedData) => {
                    if (
                      returnStep === 4 &&
                      !selectedData?.selectedMethod?.isPickup
                    ) {
                      setReturnStep(2);
                    } else {
                      setReturnStep(returnStep - 1);
                    }
                  }}
                />
              </Col>
            ) : (
              <>
                <Col sm='12' md='12' lg='12' xl='10' className='mx-autos'>
                  {/* <div
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      display: 'flex',
                      marginTop: 20,
                      marginBottom: 50,
                    }}
                  > */}
                  {/* <img src={vectorImage} style={{ height: 100, width: 100 }} /> */}
                  {/* </div> */}
                  {!showRentalHistory ? (
                    <div style={{ marginBottom: '2.5rem' }}>
                      <RentalsTable
                        loadingRentals={loadingProducts}
                        rentals={products}
                        handleOpenDetail={onProductSelected}
                        handleRefresh={refreshProducts}
                        columns={rentalsColumn}
                      />
                    </div>
                  ) : (
                    <div>
                      <RentalsTable
                        loadingRentals={loadingProductsHistory}
                        rentals={productsHistory}
                        handleOpenDetail={onProductHistorySelected}
                        handleRefresh={refreshProductsHistory}
                        columns={rentalsHistoryColumn}
                      />
                    </div>
                  )}
                  {showRentalHistory ? null : (
                    <Row>
                      {/* <Colxx
                        xxs={'12'}
                        style={{
                          textAlign: 'center',
                          marginBottom: freeSlots === 0 ? 0 : 18,
                        }}
                      >
                        <span
                          style={{ fontSize: 24 }}
                        >{`You have ${freeSlots} available rental slots`}</span>
                      </Colxx> */}
                      {/* {freeSlots === 0 ? (
                        <Colxx
                          xxs={'12'}
                          style={{
                            textAlign: 'center',
                            marginBottom: 29,
                            paddingTop: 6,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 14,
                              color: '#2E2B2B',
                              fontFamily: 'Brown',
                            }}
                          >
                            But you can still rent extra items for $15 each at
                            checkout!
                          </span>
                        </Colxx>
                      ) : null} */}
                      <Colxx xxs={'12'} style={{ textAlign: 'center' }}>
                        <div className='d-flex justify-content-center'>
                          <a
                            href={NEW_ARRIVAL_URL}
                            target='_blank'
                            rel='noreferrer'
                            style={{
                              fontFamily: 'Brown Bold',
                              height: 36,
                              paddingTop: 6,
                              paddingBottom: 6,
                            }}
                            className='btn btn-primary text-uppercase px-5'
                            // className={'actionLabelText'}
                          >
                            {strings.rent_another}
                          </a>
                        </div>
                      </Colxx>
                    </Row>
                  )}
                </Col>

                {detailOpen &&
                (modalName === 'review' ||
                  modalName === 'rentalHistoryReview') ? (
                  <ReviewDetailsModalScaffold
                    isOpen={detailOpen}
                    toggle={() => setDetailOpen(false)}
                    handleClose={() => {
                      onCloseDetailsModal();
                    }}
                    title={
                      modalName === 'review' ||
                      modalName === 'rentalHistoryReview'
                        ? 'Review'
                        : null
                    }
                    className={'rental-return-modal'}
                  >
                    {detailOpen && modalName === 'review' ? (
                      <ReviewModal
                        productData={selectedProduct}
                        detailPageButtonStates={detailPageButtonStates}
                        onClose={onCloseDetailsModal}
                        onRefresh={() => {
                          refreshProducts();
                          refreshProductsHistory();
                        }}
                      />
                    ) : modalName === 'rentalHistoryReview' ? (
                      <ReviewModal
                        productData={selectedProductHistory}
                        detailPageButtonStates={detailPageButtonStates}
                        onClose={onCloseHistoryDetailsModal}
                        onRefresh={() => {
                          refreshProducts();
                          refreshProductsHistory();
                        }}
                      />
                    ) : (
                      <RentalReturnModal
                        productData={selectedProduct}
                        onClose={onCloseDetailsModal}
                        updateProductStatus={updateProductStatus}
                      />
                    )}
                  </ReviewDetailsModalScaffold>
                ) : (
                  <DetailsModalScaffold
                    isOpen={detailOpen}
                    toggle={() => setDetailOpen(false)}
                    handleClose={() => {
                      onCloseDetailsModal();
                    }}
                    title={modalName === 'review' ? 'Review' : null}
                    className={
                      modalName === 'details'
                        ? 'rental-details-modal'
                        : 'rental-return-modal'
                    }
                    isReturn={modalName === 'return'}
                  >
                    {detailOpen &&
                      (modalName === 'details' ? (
                        <RentalModalContent
                          productData={selectedProduct}
                          onClose={onCloseDetailsModal}
                        />
                      ) : modalName === 'rentalHistoryDetails' ? (
                        <RentalModalContent
                          productData={selectedProductHistory}
                          onClose={onCloseHistoryDetailsModal}
                        />
                      ) : modalName === 'review' ? (
                        <ReviewModal
                          productData={selectedProduct}
                          detailPageButtonStates={detailPageButtonStates}
                          onClose={onCloseDetailsModal}
                        />
                      ) : modalName === 'rentalHistoryReview' ? (
                        <ReviewModal
                          productData={selectedProductHistory}
                          detailPageButtonStates={detailPageButtonStates}
                          onClose={onCloseHistoryDetailsModal}
                        />
                      ) : (
                        <RentalReturnModal
                          productData={selectedProduct}
                          onClose={onCloseDetailsModal}
                          updateProductStatus={updateProductStatus}
                        />
                      ))}
                  </DetailsModalScaffold>
                )}
              </>
            )}
          </>
        ) : (
          <BecomeMemberComponent />
        )}
      </Row>
    );
  }
};
